<template>
  <!-- Abaixo do md o rótulo vai para o atributo title: é o que dá o tooltip e mantém o
       botão identificável sem texto. Mesmo idioma do fechar do KanbanDialog. -->
  <!-- `ontos-arrives`: botão que aparece depois — o editar da ficha, que espera a leitura completa —
       entra apagado e acende, em vez de surgir de supetão. -->
  <v-btn v-if="compact" class="ontos-arrives" size="small" variant="text" icon :title="label" v-bind="$attrs">
    <v-icon size="small">{{ icon }}</v-icon>
  </v-btn>
  <!-- O slot com o rótulo por padrão: quem não o usa não muda em nada, e quem precisa de
       conteúdo formatado — um contador ao lado do texto — não precisa abandonar este
       componente e perder com ele o encolhimento para ícone. -->
  <!-- `text`, sem o retângulo, o padrão do app para os botões de cabeçalho — dentro do bloco das
       ações e fora dele, nos controles da janela (pedido do usuário). Antes do $attrs: quem pede
       outra variante (o interruptor `tonal` da listagem) continua mandando. -->
  <v-btn v-else class="ontos-arrives" size="small" variant="text" v-bind="$attrs">
    <v-icon start size="small">{{ icon }}</v-icon>
    <slot>{{ label }}</slot>
  </v-btn>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'

/**
 * Botão de cabeçalho que sabe encolher sozinho: ícone e rótulo do md para cima, só
 * ícone abaixo dele (ver `compact`). Fica aqui e não em cada tela para não virar um v-if
 * de breakpoint por botão.
 *
 * inheritAttrs: false com o repasse de $attrs é o que deixa passar `:to`, `@click`,
 * `color` e — o caso que importa — as props do ativador de um v-menu. Em Vue 3 os
 * listeners já vêm dentro de $attrs; não há mais $listeners para repassar à parte.
 */
@Component({
  name: 'ontos-header-action',
  inheritAttrs: false
})
class HeaderAction extends Vue {
  @Prop({type: String, required: true}) readonly icon!: string
  @Prop({type: String, default: ''}) readonly label!: string
  /**
   * Mantém o rótulo mesmo no xs. Para onde o ícone não basta: vários botões
   * diferentes que compartilham o mesmo ícone (dois "+" no design da coleção)
   * viram botões idênticos sem o texto.
   */
  @Prop({type: Boolean, default: false}) readonly alwaysLabel!: boolean

  /**
   * Só ícone abaixo do `md` (< 960px), e não só no telefone: na largura de um tablet, ou de um
   * telefone deitado, os rótulos já empurravam o título para as reticências (relato do usuário).
   */
  get compact(): boolean {
    return !this.alwaysLabel && this.$vuetify.display.smAndDown
  }
}

export default toNative(HeaderAction)
</script>
